import DealerInfoContainer from './DealerInfoContainer';

export default DealerInfoContainer;



// WEBPACK FOOTER //
// ./src/components/atoms/DealerInfo/index.js